/* eslint-disable @typescript-eslint/no-var-requires */
// eslint-disable-next-line @typescript-eslint/no-require-imports
const Pipedrive = require("pipedrive");
const apiClient = new Pipedrive.ApiClient();
// Configure API key authorization: api_key
const api_key = apiClient.authentications.api_key;
api_key.apiKey = "275bc87927bf4eeaf2c4fad69556235393fa7b63";

const addOrganization = async (data) => {
	const apiInstance = new Pipedrive.OrganizationsApi(apiClient);
	const opts = Pipedrive.NewOrganization.constructFromObject({
		name: `${data.franchiseBrand}`,
		owner_id: 8389323, // Michael
		visible_to: "3", // Everyone
	});
	return await apiInstance.addOrganization(opts);
};

const addPerson = async (data, orgId) => {
	const apiInstance = new Pipedrive.PersonsApi(apiClient);
	const opts = Pipedrive.NewPerson.constructFromObject({
		name: `${data.name}`,
		owner_id: 8389323,
		org_id: orgId,
		email: [{ value: data.email, primary: "true", label: "work" }],
		visible_to: "3",
		marketing_status: "subscribed",
		fa2135f8a853fc0b7cf6c560797cf841481b3b30: "Franchise Website", // the "Lead Origin" custom field
	});
	return await apiInstance.addPerson(opts);
};

const addLead = async (data, orgId, personId) => {
	const apiInstance = new Pipedrive.LeadsApi(apiClient);
	const opts = Pipedrive.AddLeadRequest.constructFromObject({
		title: `${data.name} from ${data.franchiseBrand}`,
		owner_id: 8389323,
		person_id: personId,
		organization_id: orgId,
		value: {
			amount: 8300,
			currency: "USD",
		},
		visible_to: "3",
		label_ids: ["7505b280-4572-11ee-8594-6312caa9819c"], // the "FRANCHISE WEBSITE" LABEL
	});
	return await apiInstance.addLead(opts);
};

const addNote = async (data, orgId, personId, leadId) => {
	const apiInstance = new Pipedrive.NotesApi(apiClient);
	const opts = Pipedrive.AddNoteRequest.constructFromObject({
		content: `<p>Form submission:</p><br><p>Name: ${data.name}</p><p>Email: ${data.email}</p><p>Franchise brand: ${data.franchiseBrand}</p><p>Number of open locations: ${data.locations}</p><p>12 month goal: ${data.franchiseGoals}</p><p>Registered franchise?: ${data.registeredFranchise}</p>`,
		lead_id: leadId,
		person_id: personId,
		org_id: orgId,
		pinned_to_lead_flag: 1,
		pinned_to_organization_flag: 1,
		pinned_to_person_flag: 1,
	});
	return await apiInstance.addNote(opts);
};

export { addLead, addNote, addOrganization, addPerson };
